var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionArchitectureBgShapeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 322,
    viewBox: "0 0 244 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2349_4320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -38,
    y: 0,
    width: 282,
    height: 322
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.852 -6.10352e-05L243.852 321.67L-37.9999 321.67L-37.9999 -6.43962e-05L243.852 -6.10352e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2349_4320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-146.368 188.683C-161.201 251.015 -122.691 313.568 -60.3588 328.4C-19.6797 338.078 24.03 324.6 52.239 293.727C68.9574 275.425 73.81 255.007 82.0685 232.283C107.119 163.413 151.515 85.1218 230.74 71.8001C254.023 67.8814 212.465 42.7031 206.175 39.0224C81.5283 -33.9491 -82.1862 20.2164 -135.903 155.511C-140.188 166.297 -143.676 177.394 -146.368 188.683Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-138.072 187.813C-152.227 247.307 -115.476 307.012 -55.9817 321.167C-17.1521 330.405 24.5617 317.541 51.4797 288.078C67.4382 270.609 72.071 251.116 79.9542 229.435C103.86 163.706 146.242 88.9764 221.85 76.259C244.071 72.5234 204.409 48.4895 198.402 44.9737C79.4323 -24.6743 -76.8202 27.0192 -128.093 156.152C-132.176 166.443 -135.518 177.037 -138.082 187.813L-138.072 187.813Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.778 186.943C-143.255 243.599 -108.262 300.457 -51.6059 313.934C-14.6257 322.733 25.1012 310.482 50.7282 282.42C65.9268 265.784 70.3307 247.225 77.8476 226.579C100.609 163.99 140.968 92.831 212.969 80.718C234.128 77.1564 196.36 54.2669 190.638 50.9251C77.3441 -15.3994 -71.4465 33.8312 -120.274 156.802C-124.165 166.608 -127.343 176.698 -129.787 186.952L-129.778 186.943Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-121.474 186.074C-134.283 239.891 -101.038 293.892 -47.2205 306.701C-12.0989 315.06 25.6412 303.423 49.9864 276.771C64.4159 260.968 68.6092 243.343 75.7416 223.722C97.3675 164.264 135.703 96.6765 204.096 85.1677C224.193 81.7892 188.321 60.0442 182.892 56.8672C75.2747 -6.13373 -66.0631 40.634 -112.437 157.434C-116.136 166.746 -119.148 176.332 -121.465 186.074L-121.474 186.074Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-113.178 185.195C-125.31 236.174 -93.8231 287.328 -42.8438 299.459C-9.57167 307.379 26.1725 296.355 49.2359 271.104C62.9055 256.134 66.8791 239.434 73.636 220.857C94.1175 164.54 130.429 100.513 195.216 89.6087C214.25 86.4042 180.273 65.8129 175.128 62.8006C73.1874 3.12325 -60.6884 47.4189 -104.618 158.066C-108.125 166.883 -110.972 175.966 -113.169 185.195L-113.178 185.195Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.883 184.324C-116.337 232.456 -86.599 280.771 -38.467 292.225C-7.05356 299.705 26.7038 289.295 48.4854 265.454C61.395 251.317 65.1398 235.551 71.5213 218.008C90.8675 164.832 125.156 104.367 186.335 94.0758C204.308 91.0544 172.226 71.6075 167.364 68.7601C71.1093 12.4062 -55.3228 54.239 -96.7985 158.716C-100.104 167.047 -102.805 175.617 -104.874 184.333L-104.883 184.324Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.5874 183.455C-107.364 228.749 -79.3837 274.207 -34.09 284.993C-4.52601 292.025 27.2354 282.237 47.7352 259.796C59.8849 246.493 63.4099 231.66 69.4161 215.143C87.6177 165.098 119.883 108.204 177.454 98.5171C194.374 95.6697 164.169 77.3673 159.6 74.6938C69.0224 21.6635 -49.9478 61.0242 -88.9789 159.348C-92.0919 167.185 -94.628 175.252 -96.5782 183.455L-96.5874 183.455Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88.2844 182.585C-98.3832 225.04 -72.1611 267.651 -29.7057 277.75C-1.99117 284.342 27.7742 275.159 46.9831 254.137C58.3729 241.667 61.6781 227.76 67.2997 212.286C84.357 165.381 114.608 112.049 168.563 102.975C184.42 100.311 156.111 83.1532 151.826 80.6445C66.9244 30.9378 -44.5838 67.8356 -81.1795 159.988C-84.1002 167.331 -86.4715 174.894 -88.3027 182.585L-88.2844 182.585Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-79.9885 181.715C-89.4189 221.332 -64.9455 261.096 -25.3285 270.517C0.527463 276.67 28.3061 268.1 46.2331 248.479C56.8629 236.851 59.9393 223.868 65.1947 209.43C81.1166 165.656 109.335 115.894 159.691 107.425C174.487 104.935 148.073 88.9306 144.081 86.5867C64.856 40.2035 -39.1995 74.6292 -73.3414 160.62C-76.0606 167.478 -78.2855 174.528 -79.9885 181.706L-79.9885 181.715Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.6934 180.837C-80.4464 217.615 -57.7217 254.522 -20.943 263.275C3.06349 268.989 28.8553 261.032 45.4914 242.821C55.3521 232.027 58.2179 219.978 63.0979 206.564C77.8754 165.931 104.079 119.731 150.819 111.875C164.553 109.568 140.034 94.7083 136.326 92.5292C62.7775 49.4787 -33.816 81.4324 -65.5133 161.262C-68.0403 167.625 -70.1003 174.171 -71.6843 180.837L-71.6934 180.837Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionArchitectureBgShapeGreen);
export default __webpack_public_path__ + "static/media/solution_architecture_bg_shape_green.f987070ad480f1934c1d8b2b2ed1f468.svg";
export { ForwardRef as ReactComponent };